import React, { useState } from 'react';
import './Gallery.css';

const photos = [
  { id:1,  img:'https://images.unsplash.com/photo-1589308078059-be1415eab4c3?w=700&q=80', cap:"Coaker's Walk — Morning Mist" },
  { id:2,  img:'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=700&q=80', cap:'Kodai Lake — Calm Waters' },
  { id:3,  img:'https://images.unsplash.com/photo-1501854140801-50d01698950b?w=700&q=80', cap:'Silver Cascade Waterfall' },
  { id:4,  img:'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=700&q=80', cap:'Pillar Rocks Viewpoint' },
  { id:5,  img:'https://images.unsplash.com/photo-1448375240586-882707db888b?w=700&q=80', cap:'Pine Forest Walk' },
  { id:6,  img:'https://images.unsplash.com/photo-1486870591958-9b9d0d1dda99?w=700&q=80', cap:"Dolphin's Nose Trek" },
  { id:7,  img:'https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?w=700&q=80', cap:'Mountain Road — Kodai Road to Kodaikanal' },
  { id:8,  img:'https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=700&q=80', cap:'Travel Memories' },
  { id:9,  img:'https://images.unsplash.com/photo-1504609813442-a8924e83f76e?w=700&q=80', cap:'Happy Travellers' },
  { id:10, img:'https://images.unsplash.com/photo-1494526585095-c41746248156?w=700&q=80', cap:'Winding Mountain Roads' },
  { id:11, img:'https://images.unsplash.com/photo-1500534314209-a25ddb2bd429?w=700&q=80', cap:'Valley Views' },
  { id:12, img:'https://images.unsplash.com/photo-1523531294919-4bcd7c65e216?w=700&q=80', cap:'Scenic Overlook' },
];

export default function Gallery() {
  const [lb, setLb] = useState(null);
  return (
    <div className="gallery-page page-enter">
      <div className="inner-hero" style={{ backgroundImage: "url('https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=1600&q=80')" }}>
        <div className="inner-hero__overlay" />
        <div className="container inner-hero__content">
          <p className="eyebrow">Memories &amp; Moments</p>
          <h1 className="display-title light">Photo Gallery</h1>
          <div className="amber-line" />
          <p>Scenes from our journeys — Kodaikanal's beauty through our travellers' eyes.</p>
        </div>
      </div>

      <section className="section-pad container">
        <div className="gallery-masonry">
          {photos.map(p => (
            <div key={p.id} className="gallery-item" onClick={() => setLb(p)}>
              <img src={p.img} alt={p.cap} loading="lazy" />
              <div className="gallery-item__overlay">
                <span>{p.cap}</span>
              </div>
            </div>
          ))}
        </div>
      </section>

      {lb && (
        <div className="lightbox" onClick={() => setLb(null)}>
          <button className="lightbox__close" aria-label="Close">✕</button>
          <div className="lightbox__content" onClick={e => e.stopPropagation()}>
            <img src={lb.img} alt={lb.cap} />
            <p>{lb.cap}</p>
          </div>
        </div>
      )}
    </div>
  );
}
